import {config as numberColumnConfig} from '../../common/NumberColumn';

export const prop = 'pTRetrn';

export const config = (labels) =>
	numberColumnConfig({
		id: 'gaReturned',
		label: labels.returned,
		prop,
		width: 'minmax(var(--px-140), 1fr)'
	});
